import { useEffect, useState } from "react";
import { PuffLoader } from "react-spinners";
import { useNavigate, useSearchParams } from "react-router-dom";
import StartScreen from "../../components/StartScreen";
import AvatarList from "../../components/Menu/avatar-list";

const HospitalHome = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [avatarReady, setAvatarReady] = useState(false);
  const [startSession, setStartSession] = useState(false);
  const [token, setToken] = useState();
  const [language, setLanguage] = useState("english");
  const [topic, setTopic] = useState("JkOACSfNY6xSX6PV8241EdATjeIcKWXzKAxB");
  const [APIConnection, setAPIConnection] = useState(true);
  const [mobileConnection, setMobileConnection] = useState(true);
  const [voiceConnection, setVoiceConnection] = useState(true);

  const maxRetryCount = 3;
  const maxDelaySec = 4;

  const [orientation, setOrientation] = useState("");
  const [device, setDevice] = useState("");

  const [avatarList, setAvatarList] = useState([]);
  const [activeAvatar, setActiveAvatar] = useState()

  useEffect(() => {
    // Function to update the orientation state
    function updateOrientation() {
      // eslint-disable-next-line no-restricted-globals
      setOrientation(screen.orientation.type);
      /Mobi|Android|iPhone/i.test(navigator.userAgent)
        ? setDevice("mobile")
        : setDevice("desktop");
    }

    // Initial update of the orientation state
    updateOrientation();
    // Add an event listener for orientation change
    window.addEventListener("orientationchange", updateOrientation);
    window.addEventListener("resize", updateOrientation);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("orientationchange", updateOrientation);
    };
  }, [orientation]);

  const updateNetworkStatus = () => {
    console.log(navigator.onLine);
    setMobileConnection(navigator.onLine);
  };

  async function fetchWithRetries(url, options, retries = 1) {
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        setAPIConnection(false);
        throw new Error("API ERROR");
      } else {
        return response;
      }
    } catch (err) {
      if (retries <= maxRetryCount) {
        const delay =
          Math.min(Math.pow(2, retries) / 4 + Math.random(), maxDelaySec) *
          1000;

        await new Promise((resolve) => setTimeout(resolve, delay));

        console.log(
          `Request failed, retrying ${retries}/${maxRetryCount}. Error ${err}`
        );
        return fetchWithRetries(url, options, retries + 1);
      } else {
        setAPIConnection(false);
        throw new Error(`Max retries exceeded. error: ${err}`);
      }
    }
  }

  async function login() {
    const login = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/auth/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: process.env.REACT_APP_FXAI_AUTH_EMAIL,
          password: process.env.REACT_APP_FXAI_AUTH_PASS,
        }),
      }
    );

    var response = await login.json();
    if (response.result === "OK") {
      setToken(response.data.authToken);
      setAPIConnection(true);
    } else {
      setAPIConnection(false);
    }
  }

  const handleStartSession = async () => {
    setStartSession(true);
  };

  const pullData = async () => {
    localStorage.setItem("firstVisit", false);

    const getAvatarList = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/config/passphrase/${topic}/language/${language}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    var avatarList = await getAvatarList.json();
    setAvatarList(avatarList.data);
  };

  const handleSelectAvatar = (avatar) => {
    console.log(avatar.name)
    setActiveAvatar(avatar.name)
  };

  const submitAvatar = () => {
    if(activeAvatar){
      navigate(`${activeAvatar.toLowerCase()}?homepage=true`);
    }
  }

  useEffect(() => {
    localStorage.getItem("language")
      ? setLanguage(localStorage.getItem("language"))
      : setLanguage("english");
    searchParams.get("topic")
      ? setTopic(searchParams.get("topic"))
      : setTopic("JkOACSfNY6xSX6PV8241EdATjeIcKWXzKAxB");
    updateNetworkStatus();
    login();
  }, []);

  useEffect(() => {
    if (startSession && token) {
      pullData();
    }
  }, [startSession, token]);

  useEffect(() => {
    if (avatarList && avatarList.length > 0) {
      setAvatarReady(true);
    }
  }, [avatarList]);

  useEffect(() => {
    window.addEventListener("load", updateNetworkStatus);
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("load", updateNetworkStatus);
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, [navigator.onLine]);

  return (
    <div className="outer-container">
      <div
        className={`container ${
          device !== "desktop" &&
          (orientation === "landscape-primary" ||
            orientation === "landscape-secondary")
            ? "hide"
            : "show"
        }`}
      >
       <div className="connection">
        <div className={`connection-bar ${!mobileConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/connection.svg`}></img>
          <div className="dot"></div>
        </div>
        <div className={`connection-bar ${!APIConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/llm.svg`}></img>
          <div className="dot"></div>
        </div>
        <div className={`connection-bar ${!voiceConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/voice.svg`}></img>
          <div className="dot"></div>
        </div>
       </div>
        <span className="version">v2.5.5</span>
        <div className="bottom-logo"><img src={`${process.env.PUBLIC_URL}/assets/logo.png`} /></div>
        {!startSession ? (
          <StartScreen
            language={language}
            handleStartSession={handleStartSession}
            videoSrc={`${process.env.PUBLIC_URL}/assets/hospital_start.mp4`}
            source={"hospital"}
          />
        ) : (
          <>
            <div className={`loading-container ${avatarReady ? "hide" : ""}`}>
              <PuffLoader color="#fff" size={100} />
              <span className="loading-container_text">
                {language === "english"
                  ? "Preparing the session..."
                  : "Menyiapkan sesi..."}
              </span>
            </div>
            {/* <video autoPlay muted loop id="video-bg" playsInline>
              <source src="./assets/hospital_bg.mp4" type="video/mp4" />
            </video> */}
            <div className="Menu">
              <div className="menu__header center">
                <div className="menu__title">
                  <p>
                    {language === "english" ? "SELECT AVATAR" : "PILIH AVATAR"}
                  </p>
                </div>
              </div>

              <AvatarList
                avatarList={avatarList}
                handleSelectAvatar={handleSelectAvatar}
                selectedAvatar={activeAvatar}
                handleSubmitAvatar={submitAvatar}
                origin={"hospital"}
              />

              <div className={`menu_avatar-submit ${activeAvatar ? "show" : "hide"}`} onClick={() => submitAvatar()}>Submit</div>
            </div>
          </>
        )}
      </div>
      <div
        className={`rotate-container ${
          device !== "desktop" &&
          (orientation === "landscape-primary" ||
            orientation === "landscape-secondary")
            ? "show"
            : "hide"
        }`}
      >
        <img className="rotate-img" src={`${process.env.PUBLIC_URL}/assets/rotate.png`} />
      </div>
      
    </div>
  );
};

export default HospitalHome;
